import { Form } from '../core'

$.fn.NewsletterForm = function() {
  let self = this
  self.form = undefined

  self.initialize_form = function() {
    self.form = new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: true,
      onSubmit: function() {
        $('.footer__main').css('min-height', $('.footer__main').outerHeight(false) + 'px')
      },
      onError: function() {
        $('.footer__main').css('min-height', '')
      },
      onSuccess: function() {
        let formHeight = self.outerHeight(false)
        $('.footer__main').css('min-height', '')
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success form-success--newsletter">')
          $success.html('Merci! Vous faites maintenant partie de notre liste d’envoi.').hide()
          $success.css('min-height', formHeight + 'px')
          self.after($success.fadeIn(250))
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
